<script>
import common from '@/scripts/common';

// function createHeaderCheckBox(h, c, i, itemClicked, checkboxKeyPressed) {
//     const header = h(
//         'input',
//         {
//             attrs: {
//                 type: 'checkbox'
//             },
//             on: {
//                 onClick: (e) => itemClicked(-1),
//                 onKeydown:checkboxKeyPressed
//             }
//         },
//         parentTitle
//     );

//     var checkbox = h('input', {
//         attrs: {
//             type: 'checkbox',
//             checked: c.isChecked
//         },
//         on: {
//             onClick: (e) => itemClicked(i),
//             onKeydown:checkboxKeyPressed
//         }
//     });
//     return h('label', [checkbox, c.title]);
// }

function createCheckBox(h, c, i, itemClicked, checkboxKeyPressed) {
    return h('input', {
        attrs: {
            type: 'checkbox',
            checked: c.isChecked,
            tabindex: 0
        },
        on: {
            click: (e) => itemClicked(i),
            keydown: checkboxKeyPressed
        }
    });
    //return h('label', [checkbox, c.title]);
}

// function createLabelOld(h, checkbox, title) {
//     return h('label', [checkbox, title]);
// }

function createLabel(h, item, i, itemClicked, checkboxKeyPressed) {
    return h(
        'label',
        {
            attrs: {
                // class: getCheckboxClass(item)
            }
        },
        [
            createCheckBox(h, item, i, itemClicked, checkboxKeyPressed),
            item.title
        ]
    );
}

function renderTemplate(
    h,
    listItems,
    parent,
    itemClicked,
    checkboxKeyPressed,
    boxKeyPressed
) {
    const checkboxes = listItems.map(
        (c, i) => createLabel(h, c, i, itemClicked, checkboxKeyPressed)
        // createLabelOld(
        //     h,
        //     createCheckBox(h, c, i, itemClicked, checkboxKeyPressed),
        //     c.title
        // )
        //createCheckBox(h, c, i, itemClicked, checkboxKeyPressed)
    );

    const header = createLabel(h, parent, -1, itemClicked, checkboxKeyPressed);
    // createLabel(
    //     h,
    //     createCheckBox(h, parent, -1, itemClicked, checkboxKeyPressed),
    //     parent.title
    // );

    // const header = createLabelOld(
    //     h,
    //     createCheckBox(h, parent, -1, itemClicked, checkboxKeyPressed),
    //     parent.title
    // );

    // const header = h(
    //     'input',
    //     {
    //         attrs: {
    //             type: 'checkbox'
    //         },
    //         on: {
    //             onClick: (e) => itemClicked(-1),
    //             onKeydown:checkboxKeyPressed
    //         }
    //     },
    //     parent.title
    // );
    const allCheckboxes = [
        //h('label', {}, [header, parent.title]),
        header,
        ...checkboxes
    ];

    const template = h(
        'div',
        {
            attrs: {
                class: 'checkbox-list form-control',
                tabindex: 0
            },
            on: {
                keydown: boxKeyPressed
            }
        },
        allCheckboxes
    );

    return {
        allCheckboxes,
        template
    };
}

/* eslint no-unused-vars: 'off' */
export default {
    model: {
        isEnabled: 'true'
    },
    //:bind="control1Levels" v-model="selectedLevels.control1"
    //props: ["bind", "value"]
    props: ['levels', 'selections'],
    computed: {},
    render(h) {
        const vm = this;
        const results = renderTemplate(
            h,
            vm.listItems,
            vm.parent,
            vm.itemClicked,
            vm.checkboxKeyPressed,
            vm.boxKeyPressed
        );
        vm.allCheckboxes = results.allCheckboxes;
        return results.template;
    },
    data() {
        var vm = this;
        var listItems = createListItems(vm.levels, vm.selections);
        return {
            listItems: listItems,
            parent: {
                isChecked: areAllChecked(listItems),
                title: '(Select All)'
            },
            selectedItem: -1,
            allCheckboxes: []
        };
    },
    methods: {
        boxKeyPressed,
        checkboxKeyPressed,
        itemClicked,
        updateModel
    }
};

// function getContainerClasses(itemIndex, selectedItem) {
//     return {
//         'input-container': true,
//         'blue-active': selectedItem === itemIndex
//     };
// }
// function getCheckboxClass(item) {
//     if (item.isChecked === null) return 'glyphicon glyphicon-stop';
//     if (item.isChecked === true) return 'glyphicon glyphicon-check';
//     return 'glyphicon glyphicon-unchecked';
// }

function createListItems(levels, selectedValues) {
    return levels.map((b) => ({
        isChecked: selectedValues.indexOf(b.value) >= 0,
        title: b.title,
        value: b.value
    }));
}

function areAllChecked(listItems) {
    var anyChecked = false;
    var allChecked = true;
    listItems.forEach(function (item, index) {
        if (item.isChecked === true) anyChecked = true;
        else allChecked = false;
    });
    return allChecked ? true : anyChecked ? null : false;
}

//https://stackoverflow.com/questions/53368828/refs-for-dynamically-generated-components-in-react
function boxKeyPressed(e) {
    var vm = this;
    if (
        e.keyCode === common.keyCodes.ArrowDown &&
        vm.allCheckboxes.length > 0
    ) {
        vm.allCheckboxes[0].elm.childNodes[0].focus();
        return stopEvents(e);
    }
}

function stopEvents(e) {
    if (e && e.preventDefault) {
        e.stopPropagation();
        e.preventDefault();
    }
    return false;
}

function checkboxKeyPressed(e) {
    var vm = this;
    const theCheckboxes = vm.allCheckboxes.map((c, i) => ({
        target: c.elm.childNodes[0],
        i
    }));

    const lastCheckboxIndex = theCheckboxes.length - 1;
    const s = getSelectedCheckbox(e.target, theCheckboxes);
    if (!s) return;

    switch (e.keyCode) {
        case common.keyCodes.Space:
            vm.itemClicked(s.i - 1); //Index is based on items without group checkbox, so subtract one
            return stopEvents(e);
        // case common.keyCodes.Tab:
        //     return stopEvents(e);
        case common.keyCodes.ArrowDown:
            if (s.i < lastCheckboxIndex) theCheckboxes[s.i + 1].target.focus();
            return stopEvents(e);
        case common.keyCodes.ArrowUp:
            if (s.i > 0) theCheckboxes[s.i - 1].target.focus();
            return stopEvents(e);
        //break;
    }
}

function getSelectedCheckbox(selectedCheckbox, theCheckboxes) {
    const selected = theCheckboxes.filter((c) => c.target === selectedCheckbox);
    return selected.length > 0 ? selected[0] : null;
}

function itemClicked(itemIndex) {
    var vm = this;
    var item = itemIndex === -1 ? vm.parent : vm.listItems[itemIndex];

    if (item.isChecked === true) {
        item.isChecked = false;
        if (itemIndex === -1)
            vm.listItems.forEach((item) => (item.isChecked = false));
    } else {
        item.isChecked = true;
        if (itemIndex === -1)
            vm.listItems.forEach((item) => (item.isChecked = true));
    }

    //NOT THIS
    if (itemIndex >= 0)
        vm.parent.isChecked = Boolean(areAllChecked(vm.listItems));

    // if (vm.parent.isChecked === false) {
    //     vm.parent.isChecked = true;
    // }

    //NOT THIS
    vm.updateModel();

    vm.selectedItem = itemIndex;
}
// function keyHandler(e) {
//     var vm = this;
//     e.stopPropagation();
//     e.preventDefault();
//     //if (e.type === 'keydown' && (e.code === 'Enter' || e.code === 'Space'))
//     if (e.type !== 'keydown') return;
//     if (
//         e.keyCode === common.keyCodes.Enter ||
//         e.keyCode === common.keyCodes.Space
//     ) {
//         if (e.target === vm.$refs.runReport) vm.runReport();
//         else checkForClose(vm.messageType, e.target, vm.$refs);
//     } else if (
//         e.keyCode === common.keyCodes.Tab ||
//         e.keyCode === common.keyCodes.ArrowRight ||
//         e.keyCode === common.keyCodes.ArrowUp ||
//         e.keyCode === common.keyCodes.ArrowLeft ||
//         e.keyCode === common.keyCodes.ArrowDown
//     ) {
//         console.log('focusOn (3)');
//         if (e.target === vm.$refs.goBack) vm.$refs.runReport.focus();
//         else if (e.target === vm.$refs.runReport) vm.$refs.goBack.focus();
//     }
// }

function updateModel() {
    var vm = this;
    var newValue = [];
    vm.listItems.forEach(function (item, index) {
        if (item.isChecked === true) newValue.push(item.value);
    });
    vm.$emit('checkboxesChanged', newValue);
}
</script>

<style scoped>
@media (max-width: 767px) {
    .checkbox-list {
        height: inherit;
    }
}
@media (min-width: 768px) {
    .checkbox-list {
        height: 126px;
        max-height: 126px;
        resize: none;
        overflow-y: scroll;
    }
}

.checkbox-list {
    width: 100%;
    box-sizing: border-box;
    overflow: auto;
    background-color: white;
    padding: 5px 5px 5px 5px;
    display: block;
    font-size: 14px;
    line-height: 1.42857143;
    color: #555;
    background-image: none;
    border: 1px solid #ccc;
    border-radius: 4px;
    -webkit-box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%);
    box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%);
    -webkit-transition: border-color ease-in-out 0.15s,
        -webkit-box-shadow ease-in-out 0.15s;
    -o-transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
    transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
    cursor: pointer;
}
@media (max-width: 767px) {
    .checkbox-list[data-v-1ebcd844] {
        height: inherit;
    }
}

.checkbox-list:focus div.blue-active {
    border: 1px solid rgb(161, 192, 216);
}

.parent-check-box,
.item-check-box {
    cursor: pointer;
    line-height: 22px;
    color: darkslategrey;
    padding: 0 4px 0 4px;
}

/*.item-check-box {
    margin-left: 4px;
  }*/

.glyphicon {
    margin-right: 4px;
}

/*.glyphicon.glyphicon-check {
    margin-left: -4px;
  }*/

/*.a-check-box.unchecked::before {
    content: '□';
    font-size: larger;
  }

  .a-check-box.indeterminate::before {
    content: '△';
    font-size: larger;
  }

  .a-check-box.checked::before {
    content: '■';
    font-size: larger;
  }*/

/*.book__chapter {
    display: block;
    position: reletive;
    margin-left: 40px;
  }*/

label {
    width: 100%;
    overflow: auto;
    display: block;
}

/* input[type='checkbox'] { */
/* opacity: 0; */
/* margin-left: -13px; */
/* width: 0px; */
/* } */

/* .glyphicon-check.selected:before {
    border: 4px solid rgb(161, 192, 216);
} */

/* input[type='checkbox']:focus {
    background-color: yellow;
} */

/* background-color: yellow; */
/* border: 4px solid rgb(161, 192, 216); */
/* input[type='checkbox']:focus:before {    
    width: 12px;
    margin-left: -18px;
    position: relative;
    top: 1px;
    display: inline-block;
    font-family: 'Glyphicons Halflings';
    font-style: normal;
    font-weight: 400;
    line-height: 1.2;
    -webkit-font-smoothing: antialiased;
    font-size: 15px;
    border: none;
    margin-top: -5px;
}

label.glyphicon-check > input[type='checkbox']:focus:before {
    content: '\e067';
}

label.glyphicon-unchecked > input[type='checkbox']:focus:before {
    content: '\e157';
}

label.glyphicon-stop > input[type='checkbox']:focus:before {
    content: '\e074';
} */
</style>
